var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "rotate(180 12 12)",
    fill: "#3994DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.10095 6.58101L8.7517 6.92784C8.64264 7.03699 8.58255 7.18222 8.58255 7.33743C8.58255 7.49255 8.64264 7.63794 8.7517 7.7471L12.7083 11.7035L8.74732 15.6645C8.63825 15.7735 8.57825 15.9189 8.57825 16.074C8.57825 16.2291 8.63825 16.3746 8.74732 16.4837L9.09441 16.8306C9.32012 17.0565 9.68778 17.0565 9.91349 16.8306L14.6465 12.1146C14.7555 12.0056 14.8322 11.8604 14.8322 11.7039L14.8322 11.7021C14.8322 11.5468 14.7554 11.4016 14.6465 11.2926L9.92632 6.58101C9.81734 6.47185 9.66772 6.41194 9.5126 6.41176C9.35739 6.41176 9.20984 6.47185 9.10095 6.58101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.41113,
    y: 17,
    width: 10.5882,
    height: 10.5882,
    rx: 5.29412,
    transform: "rotate(-90 6.41113 17)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f1d991534cb2929d2cbc49bc20b0dcd5.svg";
export { ForwardRef as ReactComponent };